export const API_BASE_URL = process.env.API_URL + "v1.0"
export const RECAPTCHA_KEY = process.env.RECAPTCHA_KEY
export const DEMO_SESSION_ID = process.env.DEMO_SESSION_ID
export const DEMO_ACCESS_CODE = process.env.DEMO_ACCESS_CODE
export const GOOGLE_ANALYTICS_TAG_ID = process.env.GOOGLE_ANALYTICS_TAG_ID
export const APPLICATION_INSIGHTS_CONNECTION = process.env.APPLICATION_INSIGHTS_CONNECTION
export const IS_PROD = process.env.APP_ENV === "production"